import Points from './Points';
import Wallet from './Wallet';
import PayPal from './PayPal';
import OptInOut from './OptInOut';

const index = {
  Points,
  Wallet,
  PayPal,
  OptInOut,
};

export default index;